module.exports = __webpack_public_path__ + "img/Cerrar.512827ea.svg";